import { ClinicAndOwnerClinicComponent } from '../../../admin/services/clinic-and-owner-clinic/clinic-and-owner-clinic.component';
import { SuppliersComponent } from '../../../pharmacy/suppliers/suppliers.component';
// import { SerialNumberConfirmationComponent } from '../../../clinic/protocols/serial-number-confirmation/serial-number-confirmation.component';
import { AuthenticationService } from './../../../../../../../libs/shared/src/services/authentication.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Input,
  signal,
} from '@angular/core';
import { TabsStateService } from '../../../shared/services/tabs-state.service';
import { SpeciesComponent } from '../../../admin/species/species.component';
import { CardMedicamentComponent } from '../../../pharmacy/card-medicament/card-medicament.component';
import { CensusDifferencesAndBookkeepingComponent } from '../../../pharmacy/census-differences-and-bookkeeping/census-differences-and-bookkeeping.component';
import { DissolutionOfThePharmacyComponent } from '../../../pharmacy/dissolution-of-the-pharmacy/dissolution-of-the-pharmacy.component';
import { ListMedicamentsComponent } from '../../../pharmacy/list-medicaments/list-medicaments.component';
import { MedicamentsOutputComponent } from '../../../pharmacy/medicaments-output/medicaments-output.component';
import { MinimalLagerComponent } from '../../../pharmacy/minimal-lager/minimal-lager.component';
import { ObligationOfThePharmacyComponent } from '../../../pharmacy/obligation-of-the-pharmacy/obligation-of-the-pharmacy.component';
import { OptimalLagerComponent } from '../../../pharmacy/optimal-lager/optimal-lager.component';
import { PriceListMedicamentsComponent } from '../../../pharmacy/price-list-medicaments/price-list-medicaments.component';
import { ProcurementComponent } from '../../../pharmacy/procurement/procurement.component';
import { SpendingMedicamentsGroupsComponent } from '../../../pharmacy/spending-medicaments-groups/spending-medicaments-groups.component';
import { SpendingMedicamentsComponent } from '../../../pharmacy/spending-medicaments/spending-medicaments.component';
import { StatePharmacyComponent } from '../../../pharmacy/state-pharmacy/state-pharmacy.component';
import { OwnerComponent } from '../../../clinic/owner/owner.component';
import { QrCodeGenComponent } from '../../../settings/qr-code-gen/qr-code-gen.component';
import { DashboardClinicOwnerComponent } from '../../../clinic-owner/dashboard-clinic-owner/dashboard-clinic-owner.component';
import { DashboardAdminComponent } from '../../../admin/dashboard-admin/dashboard-admin.component';
import { DashboardManagersToPayComponent } from '../../../admin/dashboard-managers-to-pay/dashboard-managers-to-pay.component';
import { DashboardUnassignedContractsComponent } from '../../../admin/dashboard-unassigned-contracts/dashboard-unassigned-contracts.component';
import { ManagerPortalDashboardComponent } from '../../../manager/manager-portal-dashboard/manager-portal-dashboard.component';
import { ManagerAtRiskContractsComponent } from '../../../manager/manager-at-risk-contracts/manager-at-risk-contracts.component';
import { ManagerOrganizationsComponent } from '../../../manager/manager-organizations/manager-organizations.component';
import { ManagerCreateOrganizationComponent } from '../../../manager/manager-create-organization/manager-create-organization.component';
import { ManagerPayoutsComponent } from '../../../manager/manager-payouts/manager-payouts.component';
import { ManagerHierarchyComponent } from '../../../manager/manager-hierarchy/manager-hierarchy.component';
import { ManagerAuditLogComponent } from '../../../manager/manager-audit-log/manager-audit-log.component';
import { ManagerSubordinatesComponent } from '../../../manager/manager-subordinates/manager-subordinates.component';
import { ManagerNotesComponent } from '../../../manager/manager-notes/manager-notes.component';
import { SettingsComponent } from '../../../settings/settings.component';
import { VeterinariansComponent } from '../../../clinic-owner/veterinarians/veterinarians.component';
import { DashboardClinicComponent } from '../../../clinic/dashboard-clinic/dashboard-clinic.component';
import { CardsComponent } from '../../../clinic/cards/cards.component';
import { ManufacturersOfMedicamentsComponent } from '../../../shared/component/manufacturers-of-medicaments/manufacturers-of-medicaments.component';
import { DebtsComponent } from '../../../clinic-owner/debts/debts.component';
import { ClinicNotesComponent } from '../../../clinic/clinic-notes/clinic-notes.component';
import { OwnerNotesComponent } from '../../../clinic-owner/owner-notes/owner-notes.component';
import { AllReportsComponent } from '../../../clinic/all-reports/all-reports.component';
import { EmailEditorComponent } from '../../../shared/component/email-editor/email-editor.component';
import { SystemDiagnoses } from '../../../admin/system-diagnoses/system-diagnoses';
import { SpeciesBreedsComponent } from '../../../shared/component/species-breeds/species-breeds.component';
import { SystemNotificationsComponent } from '../../../admin/system-notifications/system-notifications';
import { LegalDocumentsComponent } from '../../../admin/legal-documents/legal-documents';
import { SystemServices } from '../../../admin/system-services/system-services';
import { Services } from '../../../shared/component/services/services';
import { Diagnoses } from '../../../shared/component/diagnoses/diagnoses';
import { Medicaments } from '../../../shared/component/medicaments/medicaments';
import { SystemTypeMedicaments } from '../../../admin/system-type-medicaments/system-type-medicaments';
import { InterestingComponent } from '../../../admin/blogs/interesting/interesting.component';
import { TipsComponent } from '../../../admin/blogs/tips/tips.component';
import { NutritionComponent } from '../../../admin/blogs/nutrition/nutrition.component';
import { FirstAidComponent } from '../../../admin/blogs/first-aid/first-aid.component';
import { NewsComponent } from '../../../admin/blogs/news/news.component';
import { ClubsComponent } from '../../../admin/services/clubs/clubs.component';
import { OthersComponent } from '../../../admin/services/others/others.component';
import { StoresComponent } from '../../../admin/services/stores/stores.component';
import { PetInsurancesComponent } from '../../../admin/services/pet-insurances/pet-insurances.component';
import { PromotionsComponent } from '../../../admin/services/promotions/promotions.component';
import { WalkersComponent } from '../../../admin/services/walkers/walkers.component';
import { HotelsComponent } from '../../../admin/services/hotels/hotels.component';
import { TrainersComponent } from '../../../admin/services/trainers/trainers.component';
import { ManagersComponent } from '../../../admin/services/managers/managers.component';
import { GroomersComponent } from '../../../admin/services/groomers/groomers.component';
import { PetTransportersComponent } from '../../../admin/services/pet-transporters/pet-transporters.component';
import { EventsComponent } from '../../../admin/blogs/events/events.component';
import { OwnerClinicsListComponent } from '../../../clinic-owner/owner-clinics-list/owner-clinics-list.component';
import { SupportComponent } from '../../../support/support.component';
import { SubscriptionPlansComponent } from '../../../admin/subscription-plans/subscription-plans';
import { ForumTopicsComponent } from '../../../admin/forum-topics/forum-topics.component';
import { VideoTutorialsAdminComponent } from '../../../admin/video-tutorials/video-tutorials-admin.component';
import { VideoTutorialsComponent } from '../../../shared/video-tutorials/video-tutorials.component';

@Component({
  selector: 'anihis-all-pages-import',
  standalone: true,
  imports: [
    CommonModule,
    CardsComponent,
    ManufacturersOfMedicamentsComponent,
    SpeciesComponent,
    OwnerComponent,
    StatePharmacyComponent,
    SpendingMedicamentsGroupsComponent,
    SpendingMedicamentsComponent,
    ProcurementComponent,
    PriceListMedicamentsComponent,
    OptimalLagerComponent,
    ObligationOfThePharmacyComponent,
    MinimalLagerComponent,
    MedicamentsOutputComponent,
    DissolutionOfThePharmacyComponent,
    CardMedicamentComponent,
    ListMedicamentsComponent,
    CensusDifferencesAndBookkeepingComponent,
    VeterinariansComponent,
    GroomersComponent,
    PetTransportersComponent,
    ClinicAndOwnerClinicComponent,

    DashboardClinicOwnerComponent,
    DashboardClinicComponent,
    DashboardAdminComponent,
    DashboardManagersToPayComponent,
    DashboardUnassignedContractsComponent,
    ManagerPortalDashboardComponent,
    ManagerAtRiskContractsComponent,
    ManagerOrganizationsComponent,
    ManagerCreateOrganizationComponent,
    ManagerPayoutsComponent,
    ManagerHierarchyComponent,
    ManagerAuditLogComponent,
    ManagerSubordinatesComponent,
    ManagerNotesComponent,
    QrCodeGenComponent,
    SettingsComponent,
    AllReportsComponent,
    DebtsComponent,
    ClinicNotesComponent,
    OwnerNotesComponent,
    EmailEditorComponent,
    SystemDiagnoses,
    SystemNotificationsComponent,
    LegalDocumentsComponent,
    SystemServices,
    Services,
    Diagnoses,
    Medicaments,
    SystemTypeMedicaments,
    HotelsComponent,
    WalkersComponent,
    StoresComponent,
    PetInsurancesComponent,
    PromotionsComponent,
    ManufacturersOfMedicamentsComponent,
    TrainersComponent,
    ManagersComponent,
    InterestingComponent,
    TipsComponent,
    NutritionComponent,
    FirstAidComponent,
    NewsComponent,
    OthersComponent,
    ClubsComponent,
    EventsComponent,
    OwnerClinicsListComponent,
    SupportComponent,
    SuppliersComponent,
    // SerialNumberConfirmationComponent,
    SpeciesBreedsComponent,
    SubscriptionPlansComponent,
    ForumTopicsComponent,
    VideoTutorialsAdminComponent,
    VideoTutorialsComponent,
  ],
  templateUrl: './all-pages-import.component.html',
  styleUrl: './all-pages-import.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllPagesImportComponent {
  private authenticationService = inject(AuthenticationService);
  private tabsStateService = inject(TabsStateService);

  @Input() set tab(value: string) {
    this._tab = value;
    // Dodaj tab u loadedTabs čim se selektuje
    if (value && !this.loadedTabs().has(value)) {
      this.loadedTabs.update((tabs) => {
        const newTabs = new Set(tabs);
        newTabs.add(value);
        return newTabs;
      });
    }
  }
  get tab(): string {
    return this._tab;
  }
  private _tab!: string;

  userRole = this.authenticationService.getRoleFromToken();

  // Tracking učitanih tabova za @defer blokove - omogućava instant prelazak
  loadedTabs = signal<Set<string>>(new Set());

  constructor() {
    const role = this.userRole;
    if (role === 'Clinic') {
      this.loadedTabs.set(new Set(['Cards', 'Owners', 'Dashboard']));
    } else if (role === 'ClinicOwner') {
      this.loadedTabs.set(new Set(['Owners', 'Dashboard']));
    }

    // Preload every open tab so @defer blocks mount before cross-tab navigation.
    effect(() => {
      const openTabs = this.tabsStateService.tabs();
      const preloadedTabs = this.tabsStateService.preloadedTabsList();
      this.loadedTabs.update((loaded) => {
        const next = new Set(loaded);
        for (const name of openTabs) {
          if (name) next.add(name);
        }
        for (const name of preloadedTabs) {
          next.add(name);
        }
        return next.size === loaded.size && [...next].every((t) => loaded.has(t))
          ? loaded
          : next;
      });
    });
  }
}
